export default __webpack_public_path__ + "static/media/bell-icon.a0021e3d.svg";